import { Environment, RecordSource, Store, Network } from 'relay-runtime';
import serverVars from 'server-vars';
import { getBuyerToken } from 'dibs-cookie-jar';
import { createFetcher } from 'dibs-relay-network-layer/client.ts';
import { setupSubscriptions } from 'dibs-relay-network-layer/subscriptionsClient.ts';

type RecordArgs = ConstructorParameters<typeof RecordSource>;

const userType = 'buyer';
export function getRelayEnvironment(records?: RecordArgs[0]): Environment {
    const source = new RecordSource(records);
    const store = new Store(source);
    const getQueries = (): Record<string, string | undefined> => ({
        ...getBuyerToken(document.cookie),
        locale: serverVars.get('locale'),
    });

    const network = Network.create(
        createFetcher({ userType, getQueries }),
        setupSubscriptions({ getQueries, userType }).fetchOrSubscribe
    );

    return new Environment({ network, store });
}
